import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IDropdown } from "../../models/BaseModel";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { JVDate } from "../../shared/JVDate";

export interface IFilter {
    contact?: IDropdown;
    contact_ID?: number;
    status_ID?: number;
    source_ID?: number;
    country_ID?: number;
    state_ID?: number;
    city_ID?: number;
    fromDate?: Date;
    toDate?: Date;
}

const schema = yup.object({});

interface Iprops {
    filter: IFilter,
    loading: boolean,
    header: any,
    setFilter: (filter: IFilter) => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Filter = (props: Iprops) => {
    const [countries, setCountries] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    const [contacts, setContacts] = useState<IDropdown[]>();
    const [sources, setSources] = useState<IDropdown[]>();
    const [status, setStatus] = useState<IDropdown[]>();

    const { control, handleSubmit, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filter,
        shouldFocusError: false
    });

    const countryId = watch("country_ID");
    const stateId = watch("city_ID");

    useEffect(() => {
        loadCountries();
        loadStatus();
        loadSources();
    }, []);

    useEffect(() => {
        if (countryId) {
            setValue("state_ID", undefined);
            setValue("city_ID", undefined);
            setStates([]);
            setCities([]);
            loadStates(countryId);
        }
    }, [countryId]);

    useEffect(() => {
        if (stateId) {
            setValue("city_ID", undefined);
            setCities([]);
            loadCities(stateId);
        }
    }, [stateId]);

    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            const countryList = await response.json();
            setCountries([{ id: undefined, name: "--Select Country--" }, ...countryList]);
        }
    }

    const loadStatus = async () => {
        const response = await Fetch("status/dropdown", "GET", null, null, null);
        if (response) {
            const statusList = await response.json();
            setStatus([{ id: undefined, name: "--Select Status--" }, ...statusList]);
        }
    }

    const loadSources = async () => {
        const response = await Fetch("source/dropdown", "GET", null, null, null);
        if (response) {
            const sourceList = await response.json();
            setSources([{ id: undefined, name: "--Select Source--" }, ...sourceList]);
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            const stateList = await response.json();
            setStates([{ id: undefined, name: "--Select State--" }, ...stateList]);
        }
    }

    const loadCities = async (stateId: number) => {
        const response = await Fetch(`city/dropdown/${stateId}`, "GET", null, null, null);
        if (response) {
            const cityList = await response.json();
            setCities([{ id: undefined, name: "--Select City--" }, ...cityList]);
        }
    }

    const loadContacts = async (text: string | null) => {
        const query = text ? `text=${text}` : '';
        const response = await Fetch("contact_Person/dropdown", "GET", null, query, null);
        if (response) {
            setContacts(await response.json());
        }
    }
    const completeMethodContacts = (event: { query: string }) => {
        loadContacts(event.query);
    }

    const searchToDB = async (body: IFilter) => { props.setFilter(body); }

    function onSubmit(data: IFilter) {
        if (data.contact) {
            data.contact_ID = data.contact.id;
        }
        searchToDB(data);
    }

    const Clear = () => {
        reset({});
        setStates([]);
        setCities([]);
    }

    return (
        <Accordion>
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdownInput column={4} completeMethod={completeMethodContacts} label="Contact" control={control} name="contact" options={contacts} optionLabel="contact_Person_Name" placeholder="Search Contact" />
                    <JVDropdown column={4} label="Status" control={control} options={status} optionLabel="status_Name" optionValue="id" name="status_ID" placeholder="Select Status" />
                    <JVDate column={4} label="From Date" control={control} name="fromDate" />
                    <JVDate column={4} label="To Date" control={control} name="toDate" />
                    <JVDropdown column={4} label="Source" control={control} options={sources} optionLabel="source_Name" optionValue="id" name="source_ID" placeholder="Select Source" />
                    <JVDropdown column={4} label="Country" control={control} options={countries} optionLabel="country_Name" optionValue="id" name="country_ID" placeholder="Select Country" />
                    <JVDropdown column={4} label="State" control={control} options={states} optionLabel="state_Name" optionValue="id" name="state_ID" placeholder="Select State" />
                    <JVDropdown column={4} label="City" control={control} options={cities} optionLabel="city_Name" optionValue="id" name="city_ID" placeholder="Select City" />
                    <div className="col-12 md:col-3 gap-4 flex align-items-center justify-content-center mt-3">
                        <Button style={{ width: '100px', height: '34px' }} loading={props.loading} label="SEARCH" type="submit" className="p-button-rounded"></Button>
                        <Button style={{ width: '100px', height: '34px' }} label="CLEAR" onClick={Clear} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                    </div>
                </form>
            </AccordionTab>
        </Accordion>
    );
}
